import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";


export const ProgressBar = () => {

    const {
        state,
        dispatch,
    } = React.useContext(EnquiryContext)

    const containerStyles = {
        height: 8,
        width: '100%',
        backgroundColor: "#e0e0de",
        borderRadius: 50,
    }

    return (
        <div style={containerStyles}>
            <div className="h-full" style={{ width: `${(state.currentStep / (state.requiredSteps)) * 100}%`, backgroundColor: '#76ccc7', borderRadius: 'inherit', textAlign: 'right' }}>

            </div>
        </div>
    );
}
